// src/components/CreateProduct.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductList from '../components/ProductList';
import './CreateProduct.css';
const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const CreateProduct = () => {
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [productData, setProductData] = useState({
        name: '',
        description: '',
        category: '',
        stock: 0,
        price: 0,
        media: [] // Campo media para manejar imágenes y videos
    });
    const [editingProduct, setEditingProduct] = useState(null);
    const [existingMedia, setExistingMedia] = useState([]); // Cambiado a media

    useEffect(() => {
        fetchCategories();
        fetchProducts();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/categories`);
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
            alert('Error al cargar las categorías');
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/products`);
            setProducts(response.data);
        } catch (error) {
            console.error('Error fetching products:', error);
            alert('Error al cargar los productos');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleMediaChange = (e) => {
        const files = Array.from(e.target.files);
        setProductData(prevData => ({
            ...prevData,
            media: [...prevData.media, ...files] // Adjunta archivos de imagen o video
        }));
    };

    const handleRemoveExistingMedia = async (mediaUrl) => {
        if (!editingProduct || !mediaUrl) return;
        
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${apiUrl}/api/products/media`, {
                headers: { Authorization: token },
                data: { mediaUrl, productId: editingProduct._id }
            });
            
            setExistingMedia(prevMedia => prevMedia.filter(media => media !== mediaUrl));
            alert('Medio eliminado con éxito');
        } catch (error) {
           // console.error('Error eliminando el medio:', error);
            alert('Error eliminando el medio');
        }
    };

    const handleRemoveNewMedia = (index) => {
        setProductData(prevData => {
            const updatedMedia = [...prevData.media];
            updatedMedia.splice(index, 1);
            return { ...prevData, media: updatedMedia };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!productData.category) {
            alert('Debes seleccionar una categoría antes de crear un producto.');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('No estás autenticado. Por favor, inicia sesión.');
                return;
            }

            const formData = new FormData();
            formData.append('name', productData.name);
            formData.append('description', productData.description);
            formData.append('category', productData.category);
            formData.append('stock', productData.stock);
            formData.append('price', productData.price);

            productData.media.forEach(media => {
                formData.append('media', media); // Agregar todos los archivos de media
            });

            if (editingProduct) {
                await axios.put(`${apiUrl}/api/products/${editingProduct._id}`, formData, {
                    headers: {
                        Authorization: token,
                        'Content-Type': 'multipart/form-data'
                    }
                });
                alert('Producto actualizado con éxito');
                setEditingProduct(null);
            } else {
                await axios.post(`${apiUrl}/api/products`, formData, {
                    headers: {
                        Authorization: token,
                        'Content-Type': 'multipart/form-data'
                    }
                });
                alert('Producto creado con éxito');
            }

            setProductData({
                name: '',
                description: '',
                category: '',
                stock: 0,
                price: 0,
                media: []
            });
            setExistingMedia([]);
            fetchProducts();
        } catch (error) {
            console.error('Error al crear o actualizar el producto:', error);
            alert('Error: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleEdit = (product) => {
        const categoryId = typeof product.category === 'object' ? product.category._id : product.category;

        setEditingProduct(product);
        setProductData({
            name: product.name,
            description: product.description,
            category: categoryId,
            stock: product.stock,
            price: product.price,
            media: []
        });
        setExistingMedia(product.media);
    };

    const handleCancelEdit = () => {
        setEditingProduct(null);
        setProductData({
            name: '',
            description: '',
            category: '',
            stock: 0,
            price: 0,
            media: []
        });
        setExistingMedia([]);
    };

    return (
        <div className="create-product-container">
            <form onSubmit={handleSubmit} className="create-product-form">
                <h2>{editingProduct ? 'Editar Producto' : 'Crear Producto'}</h2>
                <label htmlFor="name">Nombre del Producto</label>
                <input 
                    type="text" 
                    id="name"
                    name="name" 
                    placeholder="Nombre del producto" 
                    value={productData.name} 
                    onChange={handleChange} 
                    required 
                />
                <label htmlFor="description">Descripción del Producto</label>
                <textarea 
                    id="description"
                    name="description" 
                    placeholder="Descripción del producto" 
                    value={productData.description} 
                    onChange={handleChange} 
                    required 
                />
                <label htmlFor="category">Categoría</label>
                <select 
                    id="category"
                    name="category" 
                    value={productData.category} 
                    onChange={handleChange} 
                    required
                >
                    <option value="">Selecciona una categoría</option>
                    {categories.length > 0 && categories.map(category => (
                        <option key={category._id} value={category._id}>{category.name}</option>
                    ))}
                </select>
                <label htmlFor="stock">Stock</label>
                <input
                    type="number"
                    id="stock"
                    name="stock"
                    placeholder="Stock"
                    value={productData.stock}
                    onChange={handleChange}
                    required
                />
                <label htmlFor="price">Precio en Euros</label>
                <input
                    type="number"
                    id="price"
                    name="price"
                    placeholder="Precio en euros"
                    value={productData.price}
                    onChange={handleChange}
                    required
                />
                <label htmlFor="media">Imágenes o Videos</label>
                <input
                    type="file"
                    id="media"
                    name="media"
                    multiple
                    accept="image/*,video/*"
                    onChange={handleMediaChange}
                />

                {/* Mostrar miniaturas de medios existentes */}
                <div className="existing-media">
                    {existingMedia.map((mediaUrl, index) => (
                        <div key={index} className="existing-media-item">
                            {mediaUrl.endsWith('.mp4') ? (
                                <video src={mediaUrl} width="64" height="64" controls autoPlay muted loop />
                            ) : (
                                <img src={mediaUrl} alt={`Media ${index + 1}`} className="thumbnail-image" />
                            )}
                            <button 
                                type="button" 
                                className="remove-media-button" 
                                onClick={() => handleRemoveExistingMedia(mediaUrl)}
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>

                <button type="submit">{editingProduct ? 'Actualizar Producto' : 'Crear Producto'}</button>
                {editingProduct && (
                    <button type="button" onClick={handleCancelEdit} className="cancel-button">
                        Cancelar
                    </button>
                )}
            </form>

            <h2>Lista de Productos</h2>
            <ProductList 
                  products={products} 
                  fetchProducts={fetchProducts} 
                  onEdit={handleEdit} 
                  categories={categories} 
            />
        </div>
    );
};

export default CreateProduct;
